import DataSuket from "@/services/DataSuket";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

interface SKMata {
  register_id: string;
  pasien_rm: string;
  nomor: string;
  nama: string;
  umur: string;
  sex: string | null;
  pekerjaan: string;
  alamat: string;
  exam_result: {
    1: boolean;
    2: string;
    3: string;
    4: boolean;
  };
  exam_date: Date;
  dr_id: number;
}

@Module({ store, dynamic: true, name: "storeSuket" })
class SuketStore extends VuexModule {
  skJiwa = [];
  detailskJiwa = {};
  skNapza = [];
  detailskNapza = {};
  skSehat = [];
  detailskSehat = {};
  skIstirahat = [];
  detailskIstirahat = {};
  riwayatSuket = {};
  arraySkMata: Array<SKMata>;
  skMata: SKMata = null;

  @Mutation SET_SK_JIWA(skJiwa = []) {
    this.skJiwa = skJiwa;
  }
  @Mutation SET_DETAIL_SK_JIWA(detailskJiwa = {}) {
    this.detailskJiwa = detailskJiwa;
  }

  @Mutation SET_SK_NAPZA(skNapza = []) {
    this.skNapza = skNapza;
  }
  @Mutation SET_DETAIL_SK_NAPZA(detailskNapza = {}) {
    this.detailskNapza = detailskNapza;
  }

  @Mutation SET_SK_SEHAT(skSehat = []) {
    this.skSehat = skSehat;
  }
  @Mutation SET_DETAIL_SK_SEHAT(detailskSehat = {}) {
    this.detailskSehat = detailskSehat;
  }

  @Mutation SET_SK_ISTIRAHAT(skIstirahat = []) {
    this.skIstirahat = skIstirahat;
  }
  @Mutation SET_DETAIL_SK_ISTIRAHAT(detailskIstirahat = {}) {
    this.detailskIstirahat = detailskIstirahat;
  }

  @Mutation SET_RIWAYAT_SK(riwayatSuket = {}) {
    this.riwayatSuket = riwayatSuket;
  }

  @Mutation SET_SK_MATA(data: SKMata) {
    this.skMata = data;
  }

  @Action setSKMata(data) {
    this.SET_SK_MATA(data);
  }

  @Action actRiwatarSK_on_reg(reg) {
    const dt = DataSuket.getDataRiwayatSuket(reg);
    dt.then(dt => {
      const data = dt.data;
      this.SET_RIWAYAT_SK(data);
    });
  }

  @Action clear_riwayatSK() {
    const riwayatSuket = {};
    this.SET_RIWAYAT_SK(riwayatSuket);
  }

  @Action actSKJiwa_on_reg(reg) {
    const dt = DataSuket.getDataSKJiwa(reg);
    dt.then(dt => {
      const data = dt.data;
      const detail = data[0];
      this.SET_SK_JIWA(data);
      this.SET_DETAIL_SK_JIWA(detail);
    });
  }

  @Action actSKJiwa_on_id(id) {
    const dt = DataSuket.getDataSKJiwaById(id);
    dt.then(dt => {
      const detail = dt.data;
      this.SET_DETAIL_SK_JIWA(detail);
    });
  }

  @Action actSKNapza_on_reg(reg) {
    const dt = DataSuket.getDataSKNapza(reg);
    dt.then(dt => {
      const data = dt.data;
      const detail = data[0];
      this.SET_SK_NAPZA(data);
      this.SET_DETAIL_SK_NAPZA(detail);
    });
  }

  @Action actSKNapza_on_id(id) {
    const dt = DataSuket.getDataSKNapzaById(id);
    dt.then(dt => {
      const detail = dt.data;
      this.SET_DETAIL_SK_NAPZA(detail);
    });
  }

  @Action actSKSehat_on_reg(reg) {
    const dt = DataSuket.getDataSKSehat(reg);
    dt.then(dt => {
      const data = dt.data;
      const detail = data[0];
      this.SET_SK_SEHAT(data);
      this.SET_DETAIL_SK_SEHAT(detail);
    });
  }

  @Action actSKSehat_on_id(id) {
    const dt = DataSuket.getDataSKSehatById(id);
    dt.then(dt => {
      const detail = dt.data;
      this.SET_DETAIL_SK_SEHAT(detail);
    });
  }

  @Action actSKIstirahat_on_reg(reg) {
    const dt = DataSuket.getDataSKIstirahat(reg);
    dt.then(dt => {
      const data = dt.data;
      const detail = data[0];
      this.SET_SK_ISTIRAHAT(data);
      this.SET_DETAIL_SK_ISTIRAHAT(detail);
    });
  }

  @Action actSKIstirahat_on_id(id) {
    const dt = DataSuket.getDataSKIstirahatById(id);
    dt.then(dt => {
      const detail = dt.data;
      this.SET_DETAIL_SK_ISTIRAHAT(detail);
    });
  }
}

export const storeSuket = getModule(SuketStore);
